import type { FC, ReactNode } from "react";
import { Redirect } from "react-router-dom";
import { isPageAllowed } from "src/utils/pageAccess";
import useAuth from "../hooks/useAuth";

interface AuthGuardProps {
    children?: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
    const { user, isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <Redirect to="/login" />;
    }

    if (!isPageAllowed({ user, path: window.location.pathname })) {
        return <Redirect to="/404" />;
    }

    return <>{children}</>;
};

export default AuthGuard;
